import { MRP_ROUTE, pages, SRP_ROUTE } from '../../stores/page';

export const CTA_POSITION_TOP = 'top';
export const CTA_POSITION_BOTTOM = 'bottom';
export const PAGE_NAMES = {
  MRP: pages[MRP_ROUTE],
  SRP: pages[SRP_ROUTE],
  OTHER: 'other',
};
